import { EVChargerType, EVChargerOutputType, EVChargerOutputPortType } from './evcharger';
import { Slot } from '../slot';
import { EVCStation } from '../location/evcstation';
import { Vehicle } from '../vehicle/vehicle';
import { EVCBayOutletGun } from './evcbay';
import { Commercial } from "../commercial";
import { time } from 'ionicons/icons';
export class EVChargingReservation {
    id: string
    type: ChargingReservationType
    station: EVCStation    
    slot: Slot
    status: EVChargingReservationStatus
    gun?: EVCBayOutletGun
    existingQuantity?: number
    amountToCharge?: number
    unitToCharge?: number
    vehicle?: Vehicle
    customer?: {
        profile: any
    }
    commercial?: {
        estimated?: Commercial
        actual?: Commercial
    }
    refNo?: String
    invoice?: ReservationInvoice
    discountPercentage?: number
    discountedCost?: number
    distributionCost?: number
    secretCode?: string
    bayName?: string
    portName?: string
    invoiceDetails?: InvoiceDetail[]
    stationRating?: string
    isTimeForCharging: boolean = false
    cmsAdditionalMessage?: string 
    timeCompleted? : string
    otherError?: string 
    startEndMeterDetails? : StartEndMeterDetails

    constructor(id: string, type: ChargingReservationType, station: EVCStation, slot: Slot, status: EVChargingReservationStatus, gun?: EVCBayOutletGun, existingQuantity?: number, amountToCharge?: number, unitToCharge?: number, vehicle?: Vehicle, customer?: {profile: any}, commercial?: {estimated?: Commercial, actual?: Commercial}, refNo?: String, invoice?: ReservationInvoice, discountPercentage?: number, discountedCost?: number, distributionCost?: number, secretCode?: string, bayName?: string, portName?: string, invoiceDetails?: InvoiceDetail[],cmsAdditionalMessage?: string, timeCompleted? :string, otherError? : string, startEndMeterDetails?:StartEndMeterDetails ) {
        this.id = id
        this.type = type
        this.station = station
        this.slot = slot
        this.status = status
        this.gun = gun
        this.existingQuantity = existingQuantity
        this.amountToCharge = amountToCharge
        this.unitToCharge = unitToCharge
        this.vehicle = vehicle
        this.customer = customer
        this.commercial = commercial
        this.refNo = refNo
        this.invoice = invoice
        this.discountPercentage = discountPercentage
        this.discountedCost = discountedCost
        this.distributionCost = distributionCost
        this.secretCode = secretCode
        this.bayName = bayName
        this.portName = portName
        this.invoiceDetails = invoiceDetails
        this.cmsAdditionalMessage = cmsAdditionalMessage
        this.timeCompleted = timeCompleted
        this.otherError = otherError
        this.startEndMeterDetails = startEndMeterDetails
    }
}

export class StartEndMeterDetails {
    endMeter?: String
    startMeter?: String
    constructor(endMeter: String, startMeter: String) {
        this.endMeter = endMeter
        this.startMeter = startMeter
    }
}

export class RecentlySelectedFilterCriteria {
    chargerType: EVChargerType
    outputType: EVChargerOutputType
    portType: EVChargerOutputPortType

    constructor(chargerType: EVChargerType, outputType: EVChargerOutputType, portType: EVChargerOutputPortType) {
        this.chargerType = chargerType
        this.outputType = outputType
        this.portType = portType
    }
}

export class EVChargingReservationStatus {
    id: string
    name: string

    constructor(id: string, name: string) {
        this.id = id
        this.name = name
    }
}

export class EVChargingReservationCancelReason {
    id: string
    name: string

    constructor(id: string, name: string) {
        this.id = id
        this.name = name
    }
}

export interface ChargingReservationType {
    code: EVChargingReservationTypeCode,
    info: ChargingReservationTypeInfo
}

export enum EVChargingReservationTypeCode {
    ChargeForDuration = "TB", ChargeUptoCapacity = "CB", ChargeForUnit = "UB", ChargeForAmount = "AB"
}

export class ChargingReservationTypeInfo {
    id: EVChargingReservationTypeCode
    name: string

    constructor(id: EVChargingReservationTypeCode, name: string) {
        this.id = id
        this.name = name
    }
}

export class ReservationInvoice {
    invoiceNo: string
    invoiceOn: Date
    invoiceAmount: number

    constructor(invoiceNo: string, invoiceOn: Date, invoiceAmount: number) {
        this.invoiceNo = invoiceNo
        this.invoiceOn = invoiceOn
        this.invoiceAmount = invoiceAmount
    }
}

export class EVChargingReservationProgress {
    current: number
    percentageCharged: number
    percentageRemaining: number
    power: number
    temperature: number
    timeCompleted: string
    timeRemaining: string
    unitsBalance: number
    unitsConsumed: number
    voltage: number
    refreshTime: number

    constructor(current: number,
        percentageCharged: number,
        percentageRemaining: number,
        power: number,
        temperature: number,
        timeCompleted: string,
        timeRemaining: string,
        unitsBalance: number,
        unitsConsumed: number,
        voltage: number,
        refreshTime: number) {
            this.current = current
            this.percentageCharged = percentageCharged
            this.percentageRemaining = percentageRemaining
            this.power = power
            this.temperature = temperature
            this.timeCompleted = timeCompleted
            this.timeRemaining = timeRemaining
            this.unitsBalance = unitsBalance
            this.unitsConsumed = unitsConsumed
            this.voltage = voltage
            this.refreshTime = refreshTime
    }
}

export class InvoiceDetail {
    tariffCode: string
    tariffTag: string
    ToU: string
    unitPrice: number
    unitsConsumed: number
    usageCost: number
    reservationDetailsId: string

    constructor(tariffCode: string,
        tariffTag: string,
        ToU: string,
        unitPrice: number,
        unitsConsumed: number,
        usageCost: number,
        reservationDetailsId: string) {
            this.tariffCode = tariffCode
            this.tariffTag = tariffTag
            this.ToU = ToU
            this.unitPrice = unitPrice
            this.unitsConsumed = unitsConsumed
            this.usageCost = usageCost
            this.reservationDetailsId = reservationDetailsId
        }
}